/**
 * Detects whether the current window is embedded inside an iframe.
 *
 * Comparing `window.self !== window.top` directly can throw a `SecurityError`
 * when the page is embedded in a cross-origin iframe, because the browser
 * blocks access to the top window's properties. Wrap the access in a
 * try/catch and treat a thrown error as "in iframe" (it can only happen
 * when we are actually framed by a different origin).
 */
export function isInIframe(): boolean {
  try {
    return window.self !== window.top;
  } catch {
    return true;
  }
}
